import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppConstants } from 'src/app/app.constants';
import { FormService } from 'src/app/services/form.service';
import { ModalService } from 'src/app/services/modal.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { UtilsService } from 'src/app/services/utils.service';
import { VotanteService } from 'src/app/services/votante.service';

@Component({
  selector: 'app-votantemodal',
  templateUrl: './votantemodal.component.html',
  styleUrls: ['./votantemodal.component.css']
})
export class VotantemodalComponent implements OnInit {

  @Input() data;
  form: FormGroup;
  submitted: Boolean = false;
  usuario: any;

  constructor(private activeModal: NgbActiveModal, private formService: FormService, private modal: ModalService,
    private alert: NotificacionesService, private utils: UtilsService, private votanteService: VotanteService) {
  }

  ngOnInit(): void {
    this.usuario = this.utils.obtenerDatosUsuario().usuario;
    this.form = this.formService.getVotanteModalForm(this.data, this.usuario);
  }

  accept() {
    this.submitted = true;
    if (this.form.invalid)
      return;
    this.modal.mostrarModalCargando();
    if (this.form.value.idVotante > 0)
      this.update(this.form.value);
    else
      this.save(this.form.value);
  }

  save(votante) {
    let request = {
      votante: votante.idVotante,
      idVotacion: votante.idVotacion,
      correoElectronico: votante.correoElectronico,
      usuario: votante.usuario
    };
    this.votanteService.guardar(request).subscribe((data: any) => {
      this.modal.cerrarModalCargando();
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        this.alert.success(data.mensaje, true);
        this.close();
      }
      else
        this.alert.error(data.mensaje, true);
    }, (error: any) => {
      console.error('Error', error);
      this.modal.cerrarModalCargando();
      this.alert.error('No se pudo guardar el votante, intente de nuevo', true);
    });
  }

  update(votante) {
    let request = {
      votante: votante.idVotante,
      idVotacion: votante.idVotacion,
      correoElectronico: votante.correoElectronico,
      usuario: votante.usuario
    };
    this.votanteService.actualizar(request).subscribe((data: any) => {
      this.modal.cerrarModalCargando();
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        this.alert.success(data.mensaje, true);
        this.close();
      }
      else
        this.alert.error(data.mensaje, true);
    }, (error: any) => {
      console.error('Error', error);
      this.modal.cerrarModalCargando();
      this.alert.error('No se pudo actualizar el votante, intente de nuevo', true);
    });
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  close() {
    this.activeModal.close();
  }

}
